import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import { openPullout } from '../../../Actions/stakeholderActions';
import { setVehicleDb, setBookingsDb } from '../../../Actions/dataActions';

//Pass a profile prop with the necessary details
class BookingDateAndTime extends Component {
    constructor(props) {
        super(props);

        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.openBooking = this.openBooking.bind(this);

        this.state = {
            show_tooltip: false
        };
    }

    componentDidMount() {
        if ("vehicle" in this.props.booking) {
            this.props.dispatch(setVehicleDb([this.props.booking.vehicle], this.props.data.vehicle_db))
        }
        this.props.dispatch(setBookingsDb([this.props.booking], this.props.data.bookings_db))
    }

    componentWillReceiveProps(nextProps) {
    }

    showTooltip() {
        this.setState({
            show_tooltip: true
        })
    }

    hideTooltip() {
        this.setState({
            show_tooltip: false
        })
    }

    openBooking() {
        this.props.dispatch(openPullout(this.props.booking))
    }

    render(props) {
        return (
            <div className="vehicle_cell_container date_time_container" style={{width:'auto'}} onClick={this.openBooking}>
                <div className="overlay_section_details_date_container">
                    <div className="overlay_section_details_date_left">
                        <div className="overlay_section_details_date_header">
                            { moment(this.props.booking.Start_Date ).format("ddd MMM DD")}
                        </div>
                        {
                            this.props.show_time ? 
                                <div className="overlay_section_details_date_subheader float-left">
                                    {moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mmA")}
                                </div>
                            :
                                null
                        }
                    </div>
                    <div className="overlay_section_details_date_arrow_container"><i className="fas fa-arrow-right overlay_section_details_date_arrow"></i></div>
                    <div className="overlay_section_details_date_right">
                        <div className="overlay_section_details_date_header">
                            { moment(this.props.booking.End_Date ).format("ddd MMM DD")}
                        </div>
                        {
                            this.props.show_time ? 
                                <div className="overlay_section_details_date_subheader float-left">
                                    {moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mmA")}
                                </div>
                            :
                                null
                        }
                    </div>
                </div>

                {
                    this.state.show_tooltip ?
                        <div className="vehicle_cell_tooltip_container">
                        </div>
                    :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(BookingDateAndTime)